import { useContext } from "react";
import { NumberFormatOptionsContext } from "@plansoft-configuration-renderer/utils";
/**
 * Retrieve number format options from context
 * @returns
 */
export function useNumberFormatOptions() {
    return useContext(NumberFormatOptionsContext);
}
export { useNumberFormatOptions as useAttributeNumberFormatOptions };
//# sourceMappingURL=useNumberFormatOptions.js.map